import React, { useCallback } from 'react';
import { Comment, CommentEvent } from 'types';
import { useDispatch } from 'react-redux';
import projectSlice from 'redux/reducers/project';
import { toast } from '@cognite/cogs.js';
import { getClient } from '../config/cognitesdk';

const ERROR_MESSAGE = {
  TITLE: 'Sorry',
  DESCRIPTION: 'Your comment wasn’t saved. Try again',
} as const;

export const useEventUpdate = () => {
  const dispatch = useDispatch();

  const commentEventUpdate = useCallback(
    async (comment: Comment): Promise<CommentEvent> => {
      const updatedCommentEvent: CommentEvent = {
        externalId: comment.id,
        update: {
          metadata: {
            set: {
              isCompilerResolved:
                comment.metaData?.isCompilerResolved ?? 'false',
              isParent: comment.metaData?.isParent ?? 'false',
              reviewerResponse: comment.metaData?.reviewerResponse ?? 'none',
              content: comment.commentContent,
              role: comment.role,
              createdTime: String(comment.date),
            },
          },
        },
      };

      await getClient().events.update([updatedCommentEvent]);
      return updatedCommentEvent;
    },
    []
  );

  const updateReviewComment = useCallback(
    async (comment: Comment) => {
      try {
        const response = await commentEventUpdate(comment);
        if (response) {
          dispatch(
            projectSlice.actions.updateReviewComment({
              comment,
            })
          );
          return true;
        }
        return false;
      } catch (error) {
        toast.error(
          <div>
            <h3>{ERROR_MESSAGE.TITLE}</h3>
            <p>{ERROR_MESSAGE.DESCRIPTION}</p>
          </div>
        );
        return false;
      }
    },
    [commentEventUpdate, dispatch]
  );

  return {
    updateReviewComment,
  };
};
